import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth/auth.service";
import { ContactService } from "src/app/services/contact/contact.service";
import { ReservationService } from "src/app/services/reservation/reservation.service";

declare interface RouteInfo {
  path: string;
  title: string;
  concat_title: string;
  icon: string;
  class: string;
  isBottom: boolean;
  subMenu: Array<any>;
}

export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Tableau de bord",
    concat_title: "",
    icon: "ni-tv-2 text-danger",
    class: "",
    isBottom: false,
    subMenu: [],
  },
  {
    path: "/profiles",
    title: "Utilisateurs",
    concat_title: "",
    icon: "ni-single-02 text-danger",
    class: "",
    isBottom: false,
    subMenu: [],
  },
  {
    path: "/studios",
    title: "Studios",
    concat_title: "",
    icon: "fa fa-music text-danger",
    class: "",
    isBottom: false,
    subMenu: [],
  },
  {
    path: "/reservations",
    title: "Reservations",
    concat_title: "",
    icon: "ni-bullet-list-67 text-danger",
    class: "",
    isBottom: false,
    subMenu: [],
  },
  {
    path: "/promo-codes",
    title: "Code promo",
    concat_title: "",
    icon: "ni-tag text-danger",
    class: "",
    isBottom: false,
    subMenu: [],
  },
  {
    path: "/contacts",
    title: "Messages",
    concat_title: "",
    icon: "ni-send text-dark",
    class: "",
    isBottom: true,
    subMenu: [],
  },
  {
    path: "/simulator",
    title: "Simulateur de prix",
    concat_title: "",
    icon: "fa fa-calculator text-dark",
    class: "",
    isBottom: true,
    subMenu: [],
  },
  {
    path: "/statistiques",
    title: "Suivi des SMS",
    concat_title: "",
    icon: "ni-mobile-button text-dark",
    class: "",
    isBottom: true,
    subMenu: [],
  },
  /*
  {
    path: "/export",
    title: "Exporter",
    concat_title: "",
    icon: "ni-cloud-download-95 text-dark",
    class: "",
    isBottom: true,
    subMenu: [],
  },
  */
  {
    path: "/settings",
    title: "Paramètres",
    concat_title: "",
    icon: "ni-settings-gear-65 text-dark",
    class: "",
    isBottom: true,
    subMenu: [],
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  public menuBottomItems: any[];
  public isCollapsed = true;

  loading: boolean = true;

  public passcultureItems: RouteInfo[] = [
    {
      path: "/passculture",
      title: "Réservations",
      concat_title: "",
      icon: "ni-bullet-list-67 text-info",
      class: "",
      isBottom: false,
      subMenu: [],
    },
    {
      path: "/passculture/valider",
      title: "Valider une contre-marque",
      concat_title: "",
      icon: "fa fa-check text-info",
      class: "",
      isBottom: false,
      subMenu: [],
    },
    {
      path: "/passculture-invoices",
      title: "Suivi des paiements",
      concat_title: "",
      icon: "ni-money-coins text-info",
      class: "",
      isBottom: false,
      subMenu: [],
    },
    {
      path: "/passculture/offers",
      title: "Offres",
      concat_title: "",
      icon: "ni-bullet-list-67 text-info",
      class: "",
      isBottom: false,
      subMenu: [],
    },
    {
      path: "/passculture-historiques",
      title: "Historique",
      concat_title: "",
      icon: "fa fa-history text-info",
      class: "",
      isBottom: false,
      subMenu: [],
    },
  ];

  constructor(
    private router: Router,
    private authService: AuthService,
    private contactService: ContactService,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.count_messages_no_read();
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
  }

  async count_messages_no_read() {
    var count_messages_no_read = await this.contactService
      .count_no_read()
      .then((res: any) => res.count_messages_no_read)
      .catch((err) => 0);

    var count_booking_waiting_confiremed = await this.reservationService
      .count_waiting()
      .then((res: any) => res.count_reservation_waiting)
      .catch((err) => 0);

    if (count_messages_no_read > 0) {
      var index = ROUTES.findIndex((item) => item.title == "Messages");

      if (index != -1) {
        ROUTES[index].concat_title =
          '<span class="badge badge-danger rounded ml-2">' +
          count_messages_no_read +
          "</span>";
      }
    }

    if (count_booking_waiting_confiremed > 0) {
      var index = ROUTES.findIndex((item) => item.title == "Reservations");

      if (index != -1) {
        ROUTES[index].concat_title =
          '<span class="badge badge-danger rounded ml-2">' +
          count_booking_waiting_confiremed +
          "</span>";
      }
    }

    this.filters_menu();
  }

  filters_menu() {
    this.menuItems = ROUTES.filter((menuItem) => !menuItem.isBottom);
    this.menuBottomItems = ROUTES.filter((menuItem) => menuItem.isBottom);
    this.loading = false;
  }

  logout() {
    this.authService.logout();
  }
}
